<template>
    <div class="row bg justify-content-around align-items-center">
      <div class="col-md-11">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col">
                <img src="@/assets/img/platinum_plus_product_img.jpg" class="showcase_img box-shadow" />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row description_space">
              <div class="col-md-12">
                <h4 class="pr_heading">Amana - Health Plus</h4>
                <p>Amãna Takaful Platinum Plus is the most comprehensive life and hospitalization cover in Sri Lanka.
                  In addition to the life cover, it offers hospitalization covers up to LKR 14 million. This covers not only
                  you, but your whole family. You and your spouse can also be covered for up to LKR 5 million each for
                  30 listed critical illnesses.</p>
              </div>
            </div>

            <!-- Brochure / Video / IPD buttons -->
            <div class="row align-items-end justify-content-around">
              <div class="col-sm-4">
                <button class="button_width btn btn-primary btn-block" @click="openPDF">Get Brochure</button>
              </div>
              <div class="col-sm-4">
                <button class="button_width btn btn-primary btn-block" @click="openURL('https://www.youtube.com/watch?v=7sRA7o2JEZg')">Play Video</button>
              </div>
              <div class="col-sm-4">
                <button class="button_width btn btn-primary btn-block" @click="openIPD">Get IPID</button>
              </div>
            </div>

            <!-- Product features -->
            <div class="row description_space">
              <div class="col-md-12">
                <h5 class="pr_sub_heading"><strong>Product Features</strong></h5>
                <ul class="meateaters">
                  <li>Comprehensive Hospitalization Benefits starting from 100k up to LKR 14 million for your family</li>
                  <li>Overseas hospitalization from 1mn cover and above for Malaysia, Singapore, and India</li>
                  <li>30 critical illnesses covered up to LKR 10 million for you and spouse (Optional)</li>
                  <li>Cashless facilities at times of urgent medical requirements</li>
                  <li>Flexible terms (10-30 years)</li>
                  <li>Additional unlimited Life Cover up to 5 times your basic cover (Optional)</li>
                  <li>Personal Accident Cover up to 20mn (optional)</li>
                </ul>
              </div>
            </div>

            <!-- Get Quotation -->
            <div class="row align-items-end justify-content-around">
              <div class="col-md-12">
                <button :disabled="disabledQtnBtn" class="button_width btn btn-primary mb-5 btn-block" @click="showAgreementModal = true">
                  Get Quotation
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Quotation Agreement Modal -->
      <AgreementModal
        :visible="showAgreementModal"
        :terms="agreementTerms"
        @agree="agreeAndProceed"
        @disagree="showAgreementModal = false"
      />

    </div>
</template>

<script>
import AgreementModal from "@/components/AgreementModal.vue";
import axios from "axios";

export default {
  name: "Welcome",
  components: { AgreementModal },

  data() {
    return {
      showAgreementModal: false,
      showMore : false,
      agreementTerms: [
        "I confirm that the information I provide will be accurate and complete.",
        "I consent to Amãna Takaful processing my personal data for the purpose of providing this quotation.",
        "I understand this quotation is not a binding contract and is subject to underwriting approval.",
        "I agree to the <a href='#' class='agreement-link'>Terms &amp; Conditions</a> and <a href='#' class='agreement-link'>Privacy Policy</a> of Amãna Takaful.",
      ],
      disabledQtnBtn : true
    };
  },

  methods: {
    // ── Navigation ─────────────────────────────────────────────────
    goToEvents(package_name) {
      location.href = '#/' + process.env.VUE_APP_VERSION + '/' + package_name;
    },
    agreeAndProceed() {
      this.showAgreementModal = false;
      this.goToEvents('new_quote_health_plus');
    },

    // ── Get IPD: track in background then open PDF ─────────────────
    openIPD() {
      this.disabledQtnBtn = false;
      const lang  = localStorage.getItem("lang")  || "en";
      const token = localStorage.getItem("access_token") || "";
      const base  = process.env.VUE_APP_BACKEND;

      // Fire-and-forget tracking — never blocks the PDF open
      axios.post(
        `${base}/api/v1/ipd/track`,
        {
          product_code: "health_plus",
          product_name: "Amana Health Plus",
          lang,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ).catch(() => {});

      // Open PDF immediately
      window.open(`${base}/storage/product_ipd/health_plus/${lang}.pdf`, "_blank");
    },

    // ── Brochure / Video ───────────────────────────────────────────
    openURL(link) {
      const lang = localStorage.getItem("lang");
      const base = process.env.VUE_APP_BACKEND;
      const url  = lang ? `${base}/storage/product_videos/health_plus/${lang}.mp4` : link;
      window.open(url, "_blank");
    },
    openPDF() {
      const lang = localStorage.getItem("lang");
      const base = process.env.VUE_APP_BACKEND;
      if (lang) window.open(`${base}/storage/product_brochure/health_plus/${lang}.pdf`, "_blank");
    },
  },
};
</script>

<style scoped>
.bg {
  background: white;
  min-height: 100vh;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.showcase_img { width: 100%; }
.box-shadow {
  border-radius: 8px;
  box-shadow: 0px 8px 40px 0 rgba(0, 0, 0, 0.15);
}
img { vertical-align: middle; border-style: none; }
video { width: 60%; }
.button_width { margin-top: 5px; margin-bottom: 5px; max-width: 100%; }
.pr_heading     { color: #067169; }
.pr_sub_heading { font-size: 0.95rem; color: #067169; }
.agreement-link { color: #067169; text-decoration: underline; }
@media (max-width: 768px) {
  .showcase_img { padding-top: 124px; }
}
</style>
